import * as Tooltip from '@radix-ui/react-tooltip';
import styles from './index.module.scss';

const joinClassNames = (...parts: Array<string | undefined>) => parts.filter(Boolean).join(' ');

const BustlyTooltip = ({
    children,
    content,
    side = 'top',
    contentClassName,
    arrowClassName,
    showArrow = false,
    sideOffset = 8,
    align = 'center',
    collisionPadding = 8,
    open,
    onOpenChange,
}: {
    children: React.ReactNode;
    content?: React.ReactNode;
    side?: 'top' | 'bottom' | 'left' | 'right';
    contentClassName?: string;
    arrowClassName?: string;
    showArrow?: boolean;
    sideOffset?: number;
    align?: 'start' | 'center' | 'end';
    collisionPadding?: number;
    open?: boolean;
    onOpenChange?: (open: boolean) => void;
}) => {
    if (content === undefined || content === null || content === '') {
        return children;
    }
    return (
        <Tooltip.Provider delayDuration={200}>
            <Tooltip.Root open={open} onOpenChange={onOpenChange}>
                <Tooltip.Trigger asChild>
                    {children}
                </Tooltip.Trigger>
                <Tooltip.Portal>
                    <Tooltip.Content
                        className={joinClassNames(styles['tooltip-text'], contentClassName)}
                        side={side}
                        align={align}
                        sideOffset={sideOffset}
                        collisionPadding={collisionPadding}
                        avoidCollisions
                        sticky="partial"
                    >
                        {content}
                        {showArrow ? <Tooltip.Arrow className={joinClassNames(styles['tooltip-arrow'], arrowClassName)} /> : null}
                    </Tooltip.Content>
                </Tooltip.Portal>
            </Tooltip.Root>
        </Tooltip.Provider>
    );
};
export default BustlyTooltip;
